const validateQueryParameters = (params) => {
  let query = '';

  if (params) {
    Object.keys(params).forEach(key => {
      if ((Array.isArray(params[key]) && params[key].length) || (!Array.isArray(params[key]) && (params[key] || params[key] === 0 || params[key] === false))) {
        query += `${key}=${params[key]}&`;
      }
    });
  }

  return query.slice(0, -1);
};

module.exports = { validateQueryParameters };
